// extracted by mini-css-extract-plugin
module.exports = {"login":"PhoneForm_login__XQarw","title":"PhoneForm_title__75aVT","btn":"PhoneForm_btn__saqEJ"};